import { __rest } from "tslib";
import React from 'react';
import SideContentLayout from './sideContentLayout';
import { useAppDispatch } from '@web-common/state/createStore';
import { ExpandMenuActions } from '@web-common/state/reducer';
import { TongyongZhankaiYou, TongyongZhankaiZuo } from '@sirius/icons';
import classNames from 'classnames';
import style from './expandableSideContent.module.scss';
export const ExpandableSideContent = props => {
    const { isFold, children } = props, rest = __rest(props, ["isFold", "children"]);
    const dispatch = useAppDispatch();
    if (isFold) {
        return (React.createElement("div", { className: style.expandWrapper },
            React.createElement("div", { className: classNames([style.expandBtn]), onClick: () => dispatch(ExpandMenuActions.setIsFold(false)) },
                React.createElement(TongyongZhankaiYou, null))));
    }
    return (React.createElement(SideContentLayout, Object.assign({ className: style.foldWrapper }, rest),
        React.createElement("div", { className: classNames([style.foldBtn]), onClick: () => dispatch(ExpandMenuActions.setIsFold(true)) },
            React.createElement(TongyongZhankaiZuo, null)),
        children));
};
